import React from "react";
import { AdmissionProcessWrapper } from "./styles";
import { steps } from "@website-builder/utilities-index";

const AdmissionProcess = () => {
	return (
		<AdmissionProcessWrapper>
			<div className="mainContent">
				<div className="header">The admission process</div>
				<div className="stepsContainer">
					{steps.map(({ title = "", desc = "" }, index) => (
						<div key={title + index} className="step" data-num={index + 1}>
							<div className="content">
								<div className="stepName">{title}</div>
								<div className="stepDetail">{desc}</div>
							</div>
						</div>
					))}
				</div>
			</div>
		</AdmissionProcessWrapper>
	);
};

export default AdmissionProcess;
